import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What types of cleaning services do you offer in Westbrook and Portland?',
      answer: 'Ecomez offers a complete range of cleaning services: residential cleaning for homes, commercial cleaning for offices and small businesses, regular cleaning (daily, weekly, monthly), one-time interventions, and specialized services such as window, carpet and rug cleaning.'
    },
    {
      question: 'Do you use eco-friendly products?',
      answer: 'Yes, absolutely! We primarily use eco-friendly and non-toxic cleaning products that are safe for your family, pets and the environment. We can also use your own products if you wish.'
    },
    {
      question: 'How do I get a quote for a cleaning service?',
      answer: 'You can request a free quote by filling out our contact form on this page, calling us directly, or sending us an email. We will respond quickly with a detailed estimate tailored to your specific needs.'
    },
    {
      question: 'Are your employees insured and verified?',
      answer: 'Yes, all our employees are fully insured, bonded and have passed thorough background checks. We take security and trust very seriously to give you complete peace of mind.'
    },
    {
      question: 'What are your service hours?',
      answer: 'We offer flexible hours to fit your schedule. We are available 7 days a week, including evenings and weekends. We can intervene before or after your work hours to minimize disruptions.'
    },
    {
      question: 'What happens if I am not satisfied with the cleaning?',
      answer: 'Your satisfaction is our priority. If you are not completely satisfied with our service, contact us within 24 hours and we will come back for free to correct any issues. That\'s our 100% satisfaction guarantee.'
    },
    {
      question: 'Do I need to provide equipment and cleaning products?',
      answer: 'No, we bring all our own professional equipment and cleaning products. You don\'t need to provide anything. However, if you prefer us to use specific products, we can accommodate this request.'
    },
    {
      question: 'Do you service areas outside Westbrook and Portland?',
      answer: 'Yes, we primarily serve Westbrook and Portland, but we also service surrounding areas such as South Portland, Scarborough and Gorham. Contact us to check if we cover your area.'
    }
  ];

  return (
    <section id="faq" className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            <strong>Frequently Asked Questions</strong>
          </h3>
          <p className="text-xl text-gray-600">
            Everything you need to know about our <strong>cleaning services</strong>
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h4 className="font-semibold text-gray-900 pr-4">
                  {faq.question}
                </h4>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-teal-600 flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center bg-white rounded-2xl p-8 shadow-sm">
          <i className="ri-question-line text-5xl text-teal-600 mb-4"></i>
          <h4 className="text-2xl font-bold text-gray-900 mb-3">
            Have more questions?
          </h4>
          <p className="text-gray-600 mb-6">
            Don't hesitate to contact us, our team will be happy to answer you
          </p>
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-teal-600 text-white px-8 py-3 rounded-full hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap font-semibold"
          >
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
}
